import { render, staticRenderFns } from "./OtherNotification.vue?vue&type=template&id=348243e2&"
import script from "./OtherNotification.vue?vue&type=script&lang=js&"
export * from "./OtherNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports